import { createSelector } from "reselect";
const asyncActionSelector = createSelector(
  (state, actionType) => state.asyncActions?.[actionType],
  (state) => state ?? {}
);
export {
  asyncActionSelector
};
//# sourceMappingURL=selectors.js.map
